import { DocContainerNoMenu } from '../../../components/page-content/docs/doc-container-no-menu'
import { DocsImage } from '../../../components/docs-image'
import { useAppContext } from '../../../hooks/useAppContext'

export const Page = () => {
  const {
    routeContext: { title, cover, content },
  } = useAppContext()

  return (
    <DocContainerNoMenu blogTitle={title}>
      <DocsImage src={cover} alt={title} />
      <div className="mt-5" dangerouslySetInnerHTML={{ __html: content }} />
    </DocContainerNoMenu>
  )
}

export default Page
